import {
  ChangeDetectionStrategy,
  Component,
  computed,
  Inject,
  OnInit,
  Signal,
  signal,
  WritableSignal
} from '@angular/core';
import { IGetApplicationPageForm } from "../../../../rest-clients/application/forms/i-get-application-page.form";
import { IPage } from '@zaeper/communication-lib';
import { Button } from "primeng/button";
import {
  createWidgetModalServiceInjectionToken
} from "../../../../modals/create-widget-modal/create-widget-modal-service-injection-token";
import { ICreateWidgetModalService } from "../../../../modals/create-widget-modal/i-create-widget-modal.service";
import { ICreateWidgetModalOptions } from "../../../../modals/create-widget-modal/i-create-widget-modal.options";
import { widgetServiceInjectionToken } from "../../../../services/application/widget/widget-service-injection-token";
import { IWidgetService } from "../../../../services/application/widget/i-widget.service";
import { IWidget } from "../../../../models/application/i-widget";
import {
  CardComponent,
  ConfirmationModalService,
  confirmationModalServiceInjectionToken,
  ESeverity,
  IConfirmationModalService,
  IToastService,
  toastServiceInjectionToken
} from '@zaeper/angular-dashboard-view-lib';
import { ActivatedRoute, Data, Router } from "@angular/router";
import { ApplicationOverviewItemComponent } from "../../../../components/application-overview-item";
import { ConfirmationService } from "primeng/api";
import { widgetRestClientInjectionToken } from "../../../../rest-clients/application/widget/widget-rest-client-injection-token";
import { IWidgetRestClient } from "../../../../rest-clients/application/widget/i-widget-rest.client";

@Component( {
  selector: 'app-widgets-overview-tab-component',
  templateUrl: 'widgets-overview-tab.component.html',
  imports: [
    Button, CardComponent, ApplicationOverviewItemComponent
  ],
  providers: [
    {
      provide: confirmationModalServiceInjectionToken,
      useClass: ConfirmationModalService
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
} )
export class WidgetsOverviewTabComponent implements OnInit {
  private readonly _widgetPage$: WritableSignal<IPage<IWidget> | undefined> = signal<IPage<IWidget> | undefined>( undefined );
  protected widgets$: Signal<IWidget[]> = computed( () => (this._widgetPage$()?.records) ?? [] );

  constructor(
    @Inject( createWidgetModalServiceInjectionToken ) private readonly _createWidgetModalService: ICreateWidgetModalService,
    @Inject( widgetServiceInjectionToken ) private readonly _widgetService: IWidgetService,
    @Inject( widgetRestClientInjectionToken ) private readonly _widgetRestClient: IWidgetRestClient,
    @Inject( toastServiceInjectionToken ) private readonly _toastService: IToastService,
    @Inject( confirmationModalServiceInjectionToken ) private readonly _confirmationModalService: IConfirmationModalService,
    private readonly _confirmService: ConfirmationService,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _router: Router
  ) {
  }

  ngOnInit() {
    this._activatedRoute.data.subscribe( ({ widgetPage }: Data) => {
      this._widgetPage$.set( widgetPage );
    } );
  }

  protected openCreateWidgetModal(): void {
    const options: ICreateWidgetModalOptions = {
      onConfirm: function (): void {
        throw new Error( 'Function not implemented.' );
      }
    };

    this._createWidgetModalService.open( options );
  }

  protected openWidgetDetailPage(widgetId: string): Promise<boolean> {
    return this._router.navigate( [ "de", "widget", widgetId ] );
  }

  protected async deleteWidget(
    event: Event,
    widget: IWidget
  ): Promise<void> {
    event.stopPropagation();

    const sendDeleteRequest = async () => {
      try {
        await this._widgetRestClient.deleteApplication( widget.id );

        this._toastService.setMessage( {
          title: "Erfolgreich",
          detail: "Widget wurde erfolgreich gelöscht.",
          severity: ESeverity.success
        } );

        await this._loadWidgetRecords();
      } catch ( e ) {
        this._toastService.setMessage( {
          title: "Fehler",
          detail: "Widget konnte nicht gelöscht werden.",
          severity: ESeverity.error
        } );
      }
    };

    this._confirmationModalService.open( {
      title: `${ widget.name } löschen?`,
      description: 'Dadurch werden auch alle veröffentlichten Versionen aus dem Store entfernt.',
      confirmationText: 'Löschen',
      onConfirm: () => sendDeleteRequest()
    } )
  }

  private async _loadWidgetRecords() {
    const form: IGetApplicationPageForm = {
      pageNumber: 0,
      pageSize: 100
    };

    const widgetPage: IPage<IWidget> = await this._widgetService.getWidgetPage( form );
    this._widgetPage$.set( widgetPage );
  }
}
